import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '../../lib/analytics';

/**
 * page_viewed on every route change, mounted once inside a router. `include`
 * limits it to patient-facing routes in the main app, so a staff page in the
 * same router is never recorded. Pathname only; the query is never read here.
 */
export function AnalyticsPageViews({ include }: { include?: (pathname: string) => boolean }) {
  const { pathname } = useLocation();
  const last = useRef<string | null>(null);
  useEffect(() => {
    // A re-render (or StrictMode's double effect) on the same path is not a new view.
    if (last.current === pathname) return;
    last.current = pathname;
    if (include && !include(pathname)) return;
    track('page_viewed');
  }, [pathname, include]);
  return null;
}
